import { CommentItem } from "pages/api/discuss/debate/[discussId]";
import { TYPO } from "styles/Typo";
import { TAILWIND_TO_CSS } from "utils/constant/STYLE";

{
  /*
  isMyComment 일때 nickname이 필수
  */
}

const getUniqueHue = (nickname: string) => {
  const hash = nickname.split("").reduce((acc, char) => {
    return acc + char.charCodeAt(0);
  }, 0);
  const hueIndex = hash % 24; // 0 ~ 23
  return hueIndex * 15; // 0, 15, 30, ..., 345
};
const getBgColor = (nickname: string | undefined) => {
  if (!nickname) return TAILWIND_TO_CSS["gray2"];
  const hue = getUniqueHue(nickname);
  return `hsl(${hue}, 90%, 90%)`;
};
const getTextColor = (nickname: string | undefined) => {
  if (!nickname) return "#808080";
  const hue = getUniqueHue(nickname);
  return `hsl(${hue}, 70%, 40%)`;
};

function VirtualProfile({
  data,
  isMyComment,
  nickname,
}: {
  data?: CommentItem;
  isMyComment: boolean;
  nickname?: string;
}) {
  const is_ai = data?.is_ai;
  const name = !isMyComment ? data?.nickname : nickname; // 의견/댓글 Input 에서 작성자가 입력하기 전 본인 프로필

  if (is_ai) {
    return (
      <div className="w-6 h-6 rounded-full bg-gray2 shrink-0  flex items-center justify-center relative">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
        >
          <rect
            x="6.65625"
            width="2.69216"
            height="3.14085"
            rx="1.34608"
            fill="#FFCA45"
          />
          <rect
            x="0.375"
            y="5.38281"
            width="3.14085"
            height="4.48693"
            rx="1.57043"
            fill="#F49943"
          />
          <rect
            x="12.4922"
            y="5.38281"
            width="3.14085"
            height="4.48693"
            rx="1.57043"
            fill="#F49943"
          />
          <rect
            x="6.21094"
            y="3.58984"
            width="2.69216"
            height="3.58955"
            rx="0.897387"
            transform="rotate(-90 6.21094 3.58984)"
            fill="#F49943"
          />
          <rect
            x="2.17188"
            y="1.79688"
            width="11.666"
            height="12.1147"
            rx="2.15934"
            fill="#FFE062"
          />
          <rect
            x="5.98438"
            y="9.42383"
            width="4.03824"
            height="1.34608"
            rx="0.67304"
            fill="white"
          />
          <rect
            x="9.125"
            y="5.83398"
            width="1.79477"
            height="1.79477"
            rx="0.897387"
            fill="var(--gray90)"
          />
          <rect
            x="5.08594"
            y="5.83398"
            width="1.79477"
            height="1.79477"
            rx="0.897387"
            fill="var(--gray90)"
          />
        </svg>
        <div className="absolute right-0 bottom-0 translate-x-[20%] translate-y-[13%]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
          >
            <circle cx="6" cy="6" r="5.5" fill="var(--blue40)" stroke="white" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.97708 5.79375L5.23125 7.04792L8.11875 4.16042C8.2257 4.05347 8.36181 4 8.52708 4C8.69236 4 8.82847 4.05347 8.93542 4.16042C9.04236 4.26736 9.09583 4.40347 9.09583 4.56875C9.09583 4.73403 9.04236 4.87014 8.93542 4.97708L5.63958 8.27292C5.52292 8.38958 5.38681 8.44792 5.23125 8.44792C5.07569 8.44792 4.93958 8.38958 4.82292 8.27292L3.16042 6.61042C3.05347 6.50347 3 6.36736 3 6.20208C3 6.03681 3.05347 5.90069 3.16042 5.79375C3.26736 5.68681 3.40347 5.63333 3.56875 5.63333C3.73403 5.63333 3.87014 5.68681 3.97708 5.79375Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    );
  }

  if (isMyComment && !nickname) {
    return (
      <div className="w-6 h-6 rounded-full shrink-0  flex items-center justify-center relative">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clipPath="url(#clip0_20679_19134)">
            <rect width="24" height="24" rx="12" fill="var(--blue5)" />
            <path
              d="M9.4974 13.8743C9.20573 13.8743 8.9592 13.7737 8.75781 13.5723C8.55642 13.3709 8.45573 13.1243 8.45573 12.8327C8.45573 12.541 8.55642 12.2945 8.75781 12.0931C8.9592 11.8917 9.20573 11.791 9.4974 11.791C9.78906 11.791 10.0356 11.8917 10.237 12.0931C10.4384 12.2945 10.5391 12.541 10.5391 12.8327C10.5391 13.1243 10.4384 13.3709 10.237 13.5723C10.0356 13.7737 9.78906 13.8743 9.4974 13.8743ZM14.4974 13.8743C14.2057 13.8743 13.9592 13.7737 13.7578 13.5723C13.5564 13.3709 13.4557 13.1243 13.4557 12.8327C13.4557 12.541 13.5564 12.2945 13.7578 12.0931C13.9592 11.8917 14.2057 11.791 14.4974 11.791C14.7891 11.791 15.0356 11.8917 15.237 12.0931C15.4384 12.2945 15.5391 12.541 15.5391 12.8327C15.5391 13.1243 15.4384 13.3709 15.237 13.5723C15.0356 13.7737 14.7891 13.8743 14.4974 13.8743ZM11.9974 18.666C13.8585 18.666 15.4349 18.0202 16.7266 16.7285C18.0182 15.4368 18.6641 13.8605 18.6641 11.9993C18.6641 11.666 18.6432 11.3431 18.6016 11.0306C18.5599 10.7181 18.4835 10.416 18.3724 10.1243C18.0807 10.1938 17.7891 10.2459 17.4974 10.2806C17.2057 10.3153 16.9002 10.3327 16.5807 10.3327C15.3168 10.3327 14.1224 10.0618 12.9974 9.52018C11.8724 8.97852 10.9141 8.22157 10.1224 7.24935C9.67795 8.33268 9.04253 9.27365 8.21615 10.0723C7.38976 10.8709 6.42795 11.4716 5.33073 11.8743V11.9993C5.33073 13.8605 5.97656 15.4368 7.26823 16.7285C8.5599 18.0202 10.1363 18.666 11.9974 18.666ZM11.9974 20.3327C10.8446 20.3327 9.76128 20.1139 8.7474 19.6764C7.73351 19.2389 6.85156 18.6452 6.10156 17.8952C5.35156 17.1452 4.75781 16.2632 4.32031 15.2493C3.88281 14.2355 3.66406 13.1521 3.66406 11.9993C3.66406 10.8466 3.88281 9.76324 4.32031 8.74935C4.75781 7.73546 5.35156 6.85352 6.10156 6.10352C6.85156 5.35352 7.73351 4.75977 8.7474 4.32227C9.76128 3.88477 10.8446 3.66602 11.9974 3.66602C13.1502 3.66602 14.2335 3.88477 15.2474 4.32227C16.2613 4.75977 17.1432 5.35352 17.8932 6.10352C18.6432 6.85352 19.237 7.73546 19.6745 8.74935C20.112 9.76324 20.3307 10.8466 20.3307 11.9993C20.3307 13.1521 20.112 14.2355 19.6745 15.2493C19.237 16.2632 18.6432 17.1452 17.8932 17.8952C17.1432 18.6452 16.2613 19.2389 15.2474 19.6764C14.2335 20.1139 13.1502 20.3327 11.9974 20.3327Z"
              fill="var(--blue30)"
            />
          </g>
          <defs>
            <clipPath id="clip0_20679_19134">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    );
  }

  return (
    <div
      className={`w-6 h-6 rounded-full ${
        data?.is_my_comment ? "border-[2px] border-blue40 box-content" : ""
      } bg-gray30 shrink-0 flex items-center justify-center`}
      style={{
        background: isMyComment && !nickname ? "#c0d1ff" : getBgColor(name),
      }}
    >
      <span
        className={`${TYPO.TYPO8_MD} text-gray80`}
        style={{
          color: getTextColor(name),
        }}
      >
        {name?.slice(0, 1)}
      </span>
    </div>
  );
}

export default VirtualProfile;
